// Filter pills for the Press page: one pill per Press group section after this one (sections/press-filter.liquid).
if (!customElements.get('klpd-press-filter')) {
  customElements.define(
    'klpd-press-filter',
    class KlpdPressFilter extends HTMLElement {
      connectedCallback() {
        const ownSection = this.closest('.shopify-section');
        this.groups = [...document.querySelectorAll('[data-press-group]')].filter(
          (group) => ownSection && ownSection.compareDocumentPosition(group) & Node.DOCUMENT_POSITION_FOLLOWING
        );
        if (this.groups.length < 2) return;

        const filters = this.querySelector('.video-library__filters');
        filters.replaceChildren();
        const labels = [this.dataset.allLabel || 'All', ...this.groups.map((group) => group.dataset.filterLabel)];
        this.pills = labels.map((label, index) => {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'video-library__pill';
          pill.textContent = label;
          pill.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
          pill.addEventListener('click', () => this.select(index));
          filters.appendChild(pill);
          return pill;
        });
        this.hidden = false;
      }

      // 0 shows every group; otherwise only the chosen one
      select(index) {
        this.pills.forEach((pill, i) => pill.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
        this.groups.forEach((group, i) => {
          const section = group.closest('.shopify-section') || group;
          section.hidden = index !== 0 && i !== index - 1;
        });
      }
    }
  );
}
